import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import Buildvizer from '../../assets/images/Buildvizer.png';
import start_tower from "../../assets/images/stark_tower.jpg";
import { OutlineButton } from "../../components/Buttons";

function ChannelPartnerSignup() {
  const navigate = useNavigate();

  return (
    <div
      className="flex justify-end items-center min-h-screen bg-slate-100 p-16"
      style={{
        backgroundImage: `url(${start_tower})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex rounded-md bg-white shadow-lg max-w-lg w-1/4 overflow-hidden backdrop-blur-lg bg-opacity-70">
        <div className="w-full p-8 flex flex-col items-center justify-center min-h-[400px]">
          <button
            onClick={() => navigate("/login")}
            className="text-gray-600 hover:text-gray-800 mb-6 flex items-center gap-2 text-sm font-medium self-start"
          >
            <ArrowLeft size={18} />
            Back to Login
          </button>

          <div className="flex justify-center mb-6">
            <img
              src={Buildvizer}
              alt="Company Logo"
              className="h-32 w-auto"
            />
          </div>

          <div className="flex flex-col items-center text-center">
            <div className="bg-gray-100 rounded-full p-4 mb-4">
              <Clock className="text-gray-600" size={48} />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              Coming Soon
            </h2>
            
            <p className="text-gray-600 mb-6 max-w-sm">
              Channel Partner signup is currently under development. We'll notify you when it's available.
            </p>

            <OutlineButton
              onClick={() => navigate("/login")}
              className="px-6 py-2"
            >
              Back to Login
            </OutlineButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChannelPartnerSignup;
